import { useStore } from '../store/useStore.js';

export function UniverseMap() {
  const universeStack = useStore((s) => s.universeStack);
  const focusedParentId = useStore((s) => s.focusedParentId);
  const nodes = useStore((s) => s.nodes);
  const jumpToUniverse = useStore((s) => s.jumpToUniverse);

  // Show only when we're inside at least one universe.
  if (!focusedParentId && universeStack.length === 0) return null;

  const entries = [
    { label: 'Córtex', nodeId: null as string | null, stackIdx: -1 },
    ...universeStack.map((e, i) => ({ label: e.label, nodeId: e.nodeId, stackIdx: i })),
  ];

  // If focusedParentId exists but not in stack (edge case), add it.
  if (focusedParentId && universeStack.length === 0) {
    const node = nodes.find((n) => n.id === focusedParentId);
    if (node) entries.push({ label: node.label, nodeId: node.id, stackIdx: -1 });
  }

  return (
    <div
      style={{
        position: 'fixed',
        left: 8,
        top: 'calc(var(--topbar-h) + 56px)',
        zIndex: 85,
        display: 'flex',
        flexDirection: 'column',
        gap: 0,
        maxWidth: 180,
      }}
    >
      <div style={{
        fontSize: 9, fontWeight: 700, letterSpacing: '0.10em',
        color: 'rgba(150,180,210,0.45)', textTransform: 'uppercase',
        paddingLeft: 8, marginBottom: 4,
      }}>
        Universo
      </div>
      <div style={{
        background: 'rgba(2, 6, 20, 0.80)',
        backdropFilter: 'blur(12px)',
        border: '1px solid var(--border)',
        borderRadius: 10,
        padding: '6px 0',
        overflow: 'hidden',
      }}>
        {entries.map((e, i) => {
          const isLast = i === entries.length - 1;
          const isRoot = i === 0;
          const nodeColor = e.nodeId ? (nodes.find((n) => n.id === e.nodeId)?.color ?? 'var(--neon)') : 'var(--neon)';
          return (
            <button
              key={i}
              onClick={() => jumpToUniverse(e.stackIdx)}
              title={`Ir para ${e.label}`}
              style={{
                width: '100%',
                display: 'flex',
                alignItems: 'center',
                gap: 6,
                padding: `5px 10px 5px ${8 + i * 10}px`,
                border: 'none',
                background: isLast ? 'rgba(0,245,255,0.08)' : 'transparent',
                color: isLast ? 'var(--neon)' : 'var(--muted)',
                fontSize: 11,
                fontWeight: isLast ? 600 : 400,
                cursor: isLast ? 'default' : 'pointer',
                textAlign: 'left',
                fontFamily: 'inherit',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
              }}
            >
              {/* connector line */}
              {i > 0 && (
                <span style={{ color: 'var(--muted)', opacity: 0.4, fontSize: 10, flexShrink: 0 }}>└</span>
              )}
              <span style={{
                width: 6, height: 6, borderRadius: '50%',
                background: nodeColor,
                boxShadow: isLast ? `0 0 6px ${nodeColor}` : 'none',
                flexShrink: 0,
              }} />
              <span style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>
                {e.label.length > 14 ? e.label.slice(0, 13) + '…' : e.label}
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
